import { useApi } from './useApi';

export function useStatus() {
  const { fetchData, postData, putData, data, error, loading } = useApi();

  const getStatusesApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/statuses', { params });
      
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return { 
        success: false, 
        error: err.message || 'Lỗi kết nối' 
      };
    }
  };

  return { getStatusesApi };
}